import React, { useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from 'axios';
const base_url= process.env.REACT_APP_API_URL;

const CommissionHistory = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [history, setHistory]= useState([]);
    const [originalHistory, setOriginalHistory]= useState([]);

    // Toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
      };

    const fethcHistory= async()=> {
        const auth= localStorage.getItem('admin');
        const response= await axios.get(base_url + '/api/webapi/user/commissionHistory',
            {
                headers:{
                    Accept:'application/json',
                    Authorization:`${auth}`
                }
            }
        )
        // console.log('airh',response);
        const hist= response.data.result;
        // console.log('jiys',hist);
        if(response?.data.success){
            setHistory(hist);
            setOriginalHistory(hist);
        }
    }

    const handleChange= (e)=> {
        const inputValue= e.target.value;
        
        if (inputValue === "") {
            // Reset to original fetched data when input is cleared
            setHistory(originalHistory);
        } else {
            const filterData = originalHistory.filter((val) => {
              // console.log('val',val);
              const customerName= String(val.customerName);
              const providerId= String(val.providerId);
                return customerName.includes(inputValue) || providerId.includes(inputValue);
            });
    
            setHistory(filterData);
        }
    }

    useEffect(()=>{
      window.scrollTo(0,0);
        fethcHistory();
        // console.log(history);
    },[]);



    useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    return (
        <div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>Commission History</h1>
          </div>
        </div>
      </div>
    </section>
    <div className="container-fluid">
      <div className="card">
        <div className="row">
          <div className="col-md-12">
            <div className='m-3'>
                <input type='text' placeholder='Enter customer name or provider id to seach' className='form-control'  onChange={handleChange}/>
            </div>
            <div className='mt-4'>
            <table className="table table-responsive-sm">
                <thead>
                    <tr className="p-2">
                        <th className=" text-center text-nowrap">Id</th>
                        <th className=" text-center text-nowrap">Customer Name</th>
                        <th className=" text-center text-nowrap">Provider Id</th>
                        <th className=" text-center text-nowrap">commission%</th>
                        <th className=" text-center text-nowrap">Time</th>
                    </tr>
                </thead>

                <tbody>
                    {history?.map((data)=> (
                        <tr key={data.id}>
                            <td className='text-center'>{data.id}</td>
                            <td className='text-center'>{data.customerName}</td>
                            <td className='text-center'>{data.providerId}</td>
                            <td className='text-center'>{data.commission}</td>
                            <td className='text-center'>{data.time}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="mb-4" />
    
  </div>
</div>
    )
}

export default CommissionHistory
